import script from "./FormPayrollCert.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormPayrollCert.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QBtn});qInstall(script, 'directives', {ClosePopup});
